module.exports = __webpack_public_path__ + "static/media/tom.572ed39d.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row3/tom.wav
// module id = 66
// module chunks = 0